/**
 * @generated SignedSource<<d7bf4a4ec9cd13d797fea919f399908e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type GuildMembershipLevel = "EDITOR" | "MEMBER" | "ORGANIZER" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type UserCardNew_GuildMemberships$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly guild: {
        readonly slugId: string;
        readonly " $fragmentSpreads": FragmentRefs<"GuildPrimaryPhotoNew_guild">;
      } | null | undefined;
      readonly id: string;
      readonly membershipLevel: GuildMembershipLevel;
    } | null | undefined;
  }>;
  readonly " $fragmentType": "UserCardNew_GuildMemberships";
};
export type UserCardNew_GuildMemberships$key = {
  readonly " $data"?: UserCardNew_GuildMemberships$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserCardNew_GuildMemberships">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserCardNew_GuildMemberships",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "GuildMembershipsEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GuildMembership",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "membershipLevel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Guild",
              "kind": "LinkedField",
              "name": "guild",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "slugId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "GuildPrimaryPhotoNew_guild"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GuildMembershipsConnection",
  "abstractKey": null
};

(node as any).hash = "8332c7a37a4912fdcedd91887162b324";

export default node;
